import React, { useState } from "react";
import { Link } from "react-router-dom";

const WISTERIA = "/img/wisteria.jpg";

export default function Landing() {
  const [open, setOpen] = useState(false);

  return (
    <div className="film-hero min-h-screen w-full flex items-center justify-center">
      {/* Main film frame — wisteria */}
      <img
        src={WISTERIA}
        alt="Wisteria over a sunlit stone wall in the garden"
        className="absolute inset-0 w-full h-full object-contain select-none"
        draggable={false}
      />

      {/* Letterbox bars */}
      <div className="film-bar-top" />
      <div className="film-bar-bottom" />
      <div className="film-edge-left" />

      {/* Soft hero veil so the text is readable */}
      <div className="absolute inset-0 hero-vignette z-[1]" />

      {/* WELCOME / reveal */}
      <div
        className="relative z-10 select-none cursor-pointer"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={() => setOpen((v) => !v)}
        data-testid="landing-welcome"
      >
        {!open && (
          <div className="welcome-reveal text-center" data-testid="welcome-title">
            <h1
              className="press-title text-parchment uppercase font-light"
              style={{
                fontFamily: '"Cormorant Garamond", "EB Garamond", Georgia, serif',
                letterSpacing: "0.42em",
                fontWeight: 300,
                fontSize: "clamp(2.4rem, 6.5vw, 5.5rem)",
                lineHeight: 1,
                textShadow: "0 2px 18px rgba(0,0,0,0.45)",
              }}
            >
              Welcome
            </h1>
          </div>
        )}

        {open && (
          <div className="welcome-reveal text-center px-6" data-testid="welcome-options">
            <div
              className="text-parchment/85 uppercase"
              style={{
                fontFamily: '"EB Garamond", Georgia, serif',
                letterSpacing: "0.32em",
                fontSize: "clamp(0.6rem, 2.6vw, 0.74rem)",
                fontWeight: 500,
              }}
            >
              Please choose
            </div>
            <div className="mt-4 md:mt-8 flex flex-col items-center justify-center gap-3 md:gap-8">
              <Link
                to="/house"
                onClick={(e) => e.stopPropagation()}
                className="group block text-center"
                data-testid="landing-part-1"
              >
                <div className="eyebrow text-parchment/55">Part i</div>
                <div
                  className="press-title text-parchment mt-1 md:mt-2 uppercase group-hover:text-parchment/90 transition-colors"
                  style={{
                    letterSpacing: "0.28em",
                    fontWeight: 300,
                    fontSize: "clamp(0.95rem, 4.5vw, 1.9rem)",
                  }}
                >
                  The Magicians' House
                </div>
              </Link>

              <img
                src="/seal.png"
                alt=""
                aria-hidden
                className="w-9 h-9 md:w-16 md:h-16 opacity-90 shrink-0"
                draggable={false}
                data-testid="landing-seal"
              />

              <Link
                to="/church"
                onClick={(e) => e.stopPropagation()}
                className="group block text-center"
                data-testid="landing-part-2"
              >
                <div className="eyebrow text-parchment/55">Part ii</div>
                <div
                  className="press-title text-parchment mt-1 md:mt-2 uppercase group-hover:text-parchment/90 transition-colors"
                  style={{
                    letterSpacing: "0.28em",
                    fontWeight: 300,
                    fontSize: "clamp(0.95rem, 4.5vw, 1.9rem)",
                  }}
                >
                  All Saints
                </div>
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* Footer credit */}
      <div className="absolute bottom-3 left-0 right-0 text-center z-10">
        <div
          className="font-sans uppercase text-parchment/55"
          style={{ fontSize: "0.62rem", letterSpacing: "0.32em" }}
        >
          Micklefields &middot; Stoke Ferry &middot; Est. 1770
        </div>
      </div>
    </div>
  );
}
